export const AttachmentIcon = ({ width = 24, height = 24 }) => (
  <svg
    tabIndex={-1}
    focusable="false"
    className="svg-icon icon-attachment"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      tabIndex={-1}
      d="M17.75 16H7.17002C5.08002 16 3.22002 14.47 3.02002 12.39C2.79002 10.01 4.66002 8 7.00002 8H19.36C20.67 8 21.86 8.94 21.99 10.24C22.14 11.74 20.97 13 19.5 13H9.00002C8.45002 13 8.00002 12.55 8.00002 12C8.00002 11.45 8.45002 11 9.00002 11H17.75C18.16 11 18.5 10.66 18.5 10.25C18.5 9.84 18.16 9.5 17.75 9.5H9.14002C7.83002 9.5 6.64002 10.44 6.51002 11.74C6.36002 13.24 7.53002 14.5 9.00002 14.5H19.33C21.42 14.5 23.28 12.97 23.48 10.89C23.71 8.5 21.84 6.5 19.5 6.5H7.23002C4.36002 6.5 1.79002 8.6 1.52002 11.46C1.22002 14.75 3.78002 17.5 7.00002 17.5H17.75C18.16 17.5 18.5 17.16 18.5 16.75C18.5 16.34 18.16 16 17.75 16Z"
      fill="#3F4447"
    />
    {/* <path
            tabIndex={-1}
            className="icon"
            d="M16.75 10H6.17002C4.08002 10 2.22002 8.47 2.02002 6.39C1.79002 4.01 3.66002 2 6.00002 2H18.36C19.67 2 20.86 2.94 20.99 4.24C21.14 5.74 19.97 7 18.5 7H8.00002C7.45002 7 7.00002 6.55 7.00002 6C7.00002 5.45 7.45002 5 8.00002 5H16.75C17.16 5 17.5 4.66 17.5 4.25C17.5 3.84 17.16 3.5 16.75 3.5H8.14002C6.83002 3.5 5.64002 4.44 5.51002 5.74C5.36002 7.24 6.53002 8.5 8.00002 8.5H18.33C20.42 8.5 22.28 6.97 22.48 4.89C22.71 2.5 20.84 0.5 18.5 0.5H6.23002C3.36002 0.5 0.790023 2.6 0.520023 5.46C0.220023 8.75 2.78002 11.5 6.00002 11.5H16.75C17.16 11.5 17.5 11.16 17.5 10.75C17.5 10.34 17.16 10 16.75 10Z"
            fill="#3F4447"
        />*/}
  </svg>
);
